import { Grid, TextField } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormValues } from "../../../app/slices/applicationsSlice";

const SolutionDetailsFragment = ({ errors }) => {
  const { formValues } = useSelector(({ applications }) => applications);

  const dispatch = useDispatch();

  //methods
  const handleChange = (e) => {
    let inputName = e?.target?.name;
    let inputValue = e?.target?.value;

    if (inputName === "testingPeriod") {
      const re = /^[0-9]*$/;
      if (inputValue === "" || re.test(inputValue)) {
        dispatch(
          setFormValues({
            ...formValues,
            [inputName]: inputValue,
          })
        );
      }
    } else {
      dispatch(
        setFormValues({
          ...formValues,
          [inputName]: inputValue,
        })
      );
    }
  };
  //builders
  const BuildForm = () => {
    return (
      <Grid container>
        <Grid item xs={12} md={12} className="grid-item-padding">
          <div>Describe the problem to be solved (maximum 100 words) *</div>
          <TextField
            key={"input-problem-description"}
            required
            fullWidth
            margin="dense"
            multiline
            minRows={6}
            maxRows={8}
            autoComplete="new-password"
            variant="outlined"
            error={errors["problemDescription"] ? true : false}
            helperText={
              errors["problemDescription"] ? errors.problemDescription[0] : null
            }
            name="problemDescription"
            id="problemDescription"
            // label="Problem Description"
            onChange={handleChange}
            value={formValues?.problemDescription || ""}
          />
        </Grid>
        <Grid item xs={12} md={12} className="grid-item-padding">
          <div className="mt-10">
            Describe how the proposed solution will solve the problem (maximum
            100 words) *
          </div>
          <TextField
            key={"input-solution-description"}
            required
            fullWidth
            margin="dense"
            multiline
            minRows={6}
            maxRows={8}
            autoComplete="new-password"
            variant="outlined"
            error={errors["solutionDescription"] ? true : false}
            helperText={
              errors["solutionDescription"]
                ? errors.solutionDescription[0]
                : null
            }
            name="solutionDescription"
            id="solution-description"
            // label="Solution Description"
            onChange={handleChange}
            value={formValues?.solutionDescription || ""}
          />
        </Grid>
        <Grid item xs={12} md={12} className="grid-item-padding">
          <div className="mt-10">
            Mention legal and regulatory requirements in Tanzania that challenge
            the deployment of your financial solution (maximum 100 words)
          </div>
          <TextField
            key={"input-legal-challenges"}
            required
            fullWidth
            margin="dense"
            multiline
            minRows={6}
            maxRows={8}
            autoComplete="new-password"
            variant="outlined"
            error={errors["legalChallenges"] ? true : false}
            helperText={
              errors["legalChallenges"] ? errors.legalChallenges[0] : null
            }
            name="legalChallenges"
            id="legal=challenges"
            // label="Legal Challenges"
            onChange={handleChange}
            value={formValues?.legalChallenges || ""}
          />
        </Grid>
        <Grid item xs={12} md={12} className="grid-item-padding">
          <div className="mt-10">
            Identify regulatory requirements that needs special exemption to
            facilitate testing of your financial solution (maximum 100 words)
          </div>
          <TextField
            key={"input-special-exemptions"}
            required
            fullWidth
            margin="dense"
            multiline
            minRows={6}
            maxRows={8}
            autoComplete="new-password"
            variant="outlined"
            error={errors["specialExemptions"] ? true : false}
            helperText={
              errors["specialExemptions"] ? errors.specialExemptions[0] : null
            }
            name="specialExemptions"
            id="specialExemptions"
            // label="Special Exemptions"
            onChange={handleChange}
            value={formValues?.specialExemptions || ""}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <div className="app-padding">
      <h2 className="mb-10">Solution Details</h2>
      {BuildForm()}
    </div>
  );
};

export default SolutionDetailsFragment;
